module.exports = __webpack_public_path__ + "img/icon-medal.906d1f3d.png";